import React, { PureComponent } from 'react';

import { linkList } from './styles.module.css';

class RelatedLinks extends PureComponent {
  render() {
    const { categoryLabel, subLocationLinks, onLinkClick } = this.props;

    if (!subLocationLinks || !subLocationLinks.length) return null;

    return (
      <>
        <h3>{categoryLabel} by Location</h3>
        <ul className={linkList}>
          {subLocationLinks.map(({ text, link }, index) => (
            <li key={text}>
              <a
                href={link}
                onClick={() =>
                  onLinkClick
                    ? onLinkClick({
                        anchorText: text,
                        permalink: link,
                        index,
                      })
                    : null
                }
              >
                {text}
              </a>
            </li>
          ))}
        </ul>
      </>
    );
  }
}

export default RelatedLinks;
